import PropTypes from "prop-types"

const boxScore = {
  score: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
}

export default boxScore



// WEBPACK FOOTER //
// ./src/state/shapes/NineBoxGridDrilldownScorePairShape.js